import { render, staticRenderFns } from "./WelnessIcon.vue?vue&type=template&id=7fbfefda&"
import script from "./WelnessIcon.vue?vue&type=script&setup=true&lang=ts&"
export * from "./WelnessIcon.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports